
const getPrepareEsignModalDocProps = () => {
    return {
        adminOnly: false,
        bankEditable: false,
        category: "business_location",
        comment: null,
        confirmed: false,
        creditDoc: false,
        custom: false,
        deletable: false,
        description: null,
        displayCommentable: false,
        documentKey: null,
        editable: true,
        esignReminderSentAt: null,
        esignStatus: null,
        esignable: true,
        esigned: false,
        fileUrls: [],
        filenames: [],
        files: [],
        hasUploadNotifications: null,
        headerImageUrl: null,
        helloSignRoles: [
            {
                label: "Authorized Signer",
                rid: "7890123",
                value: "signer_1"
            }
        ],
        esignSigners: [
            {
                email: "test@smartbizloans.com",
                name: "People Person",
                rid: "7890123",
                role: 'signer_1',
            }
        ],
        helloSignTemplateId: "abcedf12345",
        id: "123456778",
        instructions: "Please have your landlord sign this document",
        live: true,
        phase: "main",
        reference_files: "[]",
        rid: 123,
        signatureRequests: [],
        skippable: false,
        skipped: false,
        status: 'pending_review',
        referenceFiles: "[]",
        title: 'Landlord Subordination',
        type: 'Document::LandlordSubordination',
        uploaded: false,
    }
}
export default getPrepareEsignModalDocProps;